import Cookies from 'js-cookie'
import { env } from '@/env'

// Same names and "Bearer " prefix as @nuxtjs/auth-next so a session is shared with admin-v2.
const TOKEN_COOKIE = 'auth._token.local'
const REFRESH_COOKIE = 'auth._refresh_token.local'
const BEARER = 'Bearer '

const options = (): Cookies.CookieAttributes => ({
  domain: env.VITE_AUTH_COOKIE_DOMAIN || undefined,
  sameSite: 'lax',
  secure: location.protocol === 'https:',
  expires: 30,
})

export type TokenPair = { token: string; refresh_token?: string | undefined }

export const tokenStore = {
  getToken(): string | null {
    const value = Cookies.get(TOKEN_COOKIE)
    if (!value) return null
    return value.startsWith(BEARER) ? value.slice(BEARER.length) : value
  },
  getRefreshToken(): string | null {
    return Cookies.get(REFRESH_COOKIE) ?? null
  },
  set({ token, refresh_token }: TokenPair) {
    Cookies.set(TOKEN_COOKIE, BEARER + token, options())
    if (refresh_token) Cookies.set(REFRESH_COOKIE, refresh_token, options())
  },
  clear() {
    const { domain } = options()
    Cookies.remove(TOKEN_COOKIE, { domain })
    Cookies.remove(REFRESH_COOKIE, { domain })
  },
}
